export const VIABILITYDATA = "VIABILITYDATA";
export const VIABILITYDATASUBROGATION = "VIABILITYDATASUBROGATION";
export const OPERATIONIDVIABILITY = "OPERATIONIDVIABILITY";
